export default __webpack_public_path__ + "static/char-s-32-ja-ee2b940412266a17d6c00543eabce2ce.png";